import { formatDateTime } from './dateHelpers';

const imprimirHTML = (html) => {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  }, 250);
};

export const imprimirTicketCierre = (caja, sucursalNombre, egresosDetalle = []) => {
  const totalCalculado = (parseFloat(caja.monto_apertura) +
      parseFloat(caja.totales?.ingresos_efectivo || 0) +
      parseFloat(caja.totales?.ingresos_transferencia || 0) +
      parseFloat(caja.totales?.ingresos_pos || 0) +
      parseFloat(caja.totales?.ingresos_cheque || 0) -
      parseFloat(caja.totales?.total_egresos || 0)).toFixed(2);

  const montoCierre = caja.monto_cierre ? parseFloat(caja.monto_cierre).toFixed(2) : totalCalculado;

  const desgloseTransferencias = caja.desglose_transferencias || [];
  const desglosePos = caja.desglose_pos || [];
  const desgloseHTML = (desgloseTransferencias.length > 0 || desglosePos.length > 0) ? `
        ${desgloseTransferencias.map(d => `
          <div class="row" style="font-size: 12px; padding-left: 10px;">
            <span>&bull; ${d.nombre}${d.banco ? ` (${d.banco})` : ''}</span>
            <span>Q${parseFloat(d.total).toFixed(2)}</span>
          </div>
        `).join('')}
        ${desglosePos.map(d => `
          <div class="row" style="font-size: 12px; padding-left: 10px;">
            <span>&bull; ${d.nombre}</span>
            <span>Q${parseFloat(d.total).toFixed(2)}</span>
          </div>
        `).join('')}
  ` : '';

  const egresos = (egresosDetalle || []).filter(m => m.tipo === 'egreso');
  const egresosHTML = egresos.length > 0 ? `
        <div class="divider"></div>
        <h3 style="font-size: 13px;">DETALLE DE EGRESOS</h3>
        ${egresos.map((e, idx) => `
          <div class="row" style="font-size: 12px;">
            <span>${idx + 1}. ${e.concepto}${e.categoria_nombre ? ` (${e.categoria_nombre})` : ''} [${e.metodo_pago}]</span>
            <span>Q${parseFloat(e.monto).toFixed(2)}</span>
          </div>
        `).join('')}
        <div class="row bold" style="font-size: 12px; border-top: 1px dashed #000; padding-top: 3px; margin-top: 3px;">
          <span>Total Egresos (${egresos.length}):</span>
          <span>Q${egresos.reduce((sum, e) => sum + parseFloat(e.monto), 0).toFixed(2)}</span>
        </div>
  ` : '';

  const html = `
    <html>
      <head>
        <title>Corte de Caja #${caja.id}</title>
        <style>
          body { font-family: monospace; padding: 20px; width: 300px; margin: 0 auto; color: #000; }
          h2, h3 { text-align: center; margin: 5px 0; }
          .divider { border-top: 1px dashed #000; margin: 10px 0; }
          .row { display: flex; justify-content: space-between; margin-bottom: 3px; }
          .bold { font-weight: bold; }
        </style>
      </head>
      <body>
        <h2>TALLER INTERSECOM</h2>
        <h3>CORTE DE CAJA</h3>
        <p style="text-align:center;">Sucursal: ${sucursalNombre || 'N/A'}</p>
        <div class="divider"></div>
        <div class="row"><span>Fecha Ap:</span> <span>${formatDateTime(caja.fecha_apertura)}</span></div>
        <div class="row"><span>Fecha Cierre:</span> <span>${caja.fecha_cierre ? formatDateTime(caja.fecha_cierre) : formatDateTime(new Date())}</span></div>
        <div class="row"><span>Estado:</span> <span>${caja.estado.toUpperCase()}</span></div>
        <div class="divider"></div>
        <div class="row"><span>Fondo Inicial:</span> <span>Q${parseFloat(caja.monto_apertura).toFixed(2)}</span></div>
        <div class="row"><span>Ingresos Efectivo:</span> <span>Q${parseFloat(caja.totales?.ingresos_efectivo || caja.monto_efectivo || 0).toFixed(2)}</span></div>
        <div class="row"><span>Ingresos Transf.:</span> <span>Q${parseFloat(caja.totales?.ingresos_transferencia || caja.monto_transferencias || 0).toFixed(2)}</span></div>
        <div class="row"><span>Ingresos POS:</span> <span>Q${parseFloat(caja.totales?.ingresos_pos || caja.monto_pos || 0).toFixed(2)}</span></div>
        ${desgloseHTML}
        <div class="row"><span>Egresos:</span> <span>Q${parseFloat(caja.totales?.total_egresos || caja.monto_egresos || 0).toFixed(2)}</span></div>
        <div class="divider"></div>
        <div class="row bold"><span>Total Calculado:</span> <span>Q${totalCalculado}</span></div>
        <div class="row bold"><span>Total Declarado:</span> <span>Q${montoCierre}</span></div>
        ${egresosHTML}
        <div class="divider"></div>
        <p style="text-align:center; font-size:12px;">Firmas</p>
        <br/><br/><br/>
        <div class="row" style="text-align:center; display:block;">
            <p>_________________________</p>
            <p>Firma Cajero</p>
        </div>
      </body>
    </html>
  `;

  imprimirHTML(html);
};

export const imprimirReciboMovimiento = (movimiento, sucursalNombre) => {
  const esIngreso = movimiento.tipo === 'ingreso';

  const html = `
    <html>
      <head>
        <title>Recibo de ${esIngreso ? 'Ingreso' : 'Egreso'} #${movimiento.id}</title>
        <style>
          body { font-family: monospace; padding: 20px; width: 300px; margin: 0 auto; color: #000; }
          h2, h3 { text-align: center; margin: 5px 0; }
          .divider { border-top: 1px dashed #000; margin: 10px 0; }
          .row { display: flex; justify-content: space-between; margin-bottom: 3px; }
          .bold { font-weight: bold; }
        </style>
      </head>
      <body>
        <h2>TALLER INTERSECOM</h2>
        <h3>RECIBO DE ${esIngreso ? 'INGRESO' : 'EGRESO'}</h3>
        <p style="text-align:center;">Sucursal: ${sucursalNombre || 'N/A'}</p>
        <div class="divider"></div>
        <div class="row"><span>Nro Movimiento:</span> <span>${movimiento.id}</span></div>
        <div class="row"><span>Fecha:</span> <span>${formatDateTime(movimiento.fecha)}</span></div>
        <div class="row"><span>Tipo:</span> <span>${movimiento.tipo.toUpperCase()}</span></div>
        <div class="row"><span>Concepto:</span> <span>${movimiento.concepto}</span></div>
        <div class="row"><span>Método Pago:</span> <span>${movimiento.metodo_pago}</span></div>
        ${movimiento.comprobante ? `<div class="row"><span>Comprobante:</span> <span>${movimiento.comprobante}</span></div>` : ''}
        <div class="divider"></div>
        <div class="row bold" style="font-size: 16px;"><span>TOTAL:</span> <span>Q${parseFloat(movimiento.monto).toFixed(2)}</span></div>
        <div class="divider"></div>
        <p style="text-align:center; font-size:12px;">Firmas</p>
        <br/><br/><br/>
        <div class="row" style="text-align:center; display:block;">
            <p>_________________________</p>
            <p>Firma Cajero</p>
        </div>
      </body>
    </html>
  `;

  imprimirHTML(html);
};
